import { DECIMAL_PLACES } from 'common/config/app';
import { getArrayValue, getNumberValue, parseCellValue } from 'utilities';
import { FieldAttributesFields, UpdateFieldValueParams } from './updateFieldValue.types';

const updateFieldValue = (params: UpdateFieldValueParams): void => {
  const { cell, fieldAttributes, field, fundInvestmentUuid, setFundInvestmentDetails } = params;

  let fieldDecimalPlaces = DECIMAL_PLACES;

  if (field in fieldAttributes) {
    fieldDecimalPlaces = getNumberValue(fieldAttributes[field as FieldAttributesFields]?.decimal_places);
  }

  const parsedCellValue = parseCellValue({ cell, fieldDecimalPlaces });

  setFundInvestmentDetails(prevState => {
    const updatedFundInvestmentDetails = getArrayValue(prevState).map(fundInvestmentDetail => {
      if (fundInvestmentDetail?.uuid === fundInvestmentUuid) {
        return {
          ...fundInvestmentDetail,
          [field]: parsedCellValue,
        };
      }

      return fundInvestmentDetail;
    });

    return updatedFundInvestmentDetails;
  });
};

export default updateFieldValue;
